export const COOKIE_NAME = {
  ACCESS_TOKEN: 'at'
}
